import React from "react";
import { FaFileExcel } from "react-icons/fa";

const AgencyPitchesMobileHeader = ({ onExport, exportingData, disabled }) => {
  return (
    <div className="px-4 py-3 bg-white flex justify-between items-center border-b border-[#E5E6E8]">
      <h1 className="text-lg font-bold text-[#202630]">Agency Pitches</h1>
      <button
        onClick={onExport}
        disabled={exportingData || disabled}
        className="flex items-center gap-2 px-3 py-1.5 bg-[#2283FF] text-white text-xs rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {exportingData ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Exporting...</span>
          </>
        ) : (
          <>
            <FaFileExcel className="w-3 h-3" />
            <span>Export</span>
          </>
        )}
      </button>
    </div>
  );
};

export default AgencyPitchesMobileHeader;